import styled from 'styled-components'
import { Badge } from 'react-bootstrap'
import { rgba } from 'polished'

export const FormCard = styled.div`
  margin-bottom: 1.25rem;
`

export const FormHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 1rem;
  margin-bottom: 1rem;
`

export const FormHelperText = styled.small`
  color: ${props => rgba(props.theme.colors.textPrimary, 0.7)};
`

export const FooterActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  margin-top: 1rem;
`

export const SectionTitle = styled.h4`
  margin: 0 0 1rem;
`

export const SummaryText = styled.span`
  display: inline-block;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const QuantityBadge = styled(Badge)`
  min-width: 2rem;
  background-color: transparent !important;
  border: 1px solid ${props => rgba(props.theme.colors.textPrimary, 0.35)};
  color: ${props => props.theme.colors.textPrimary} !important;
`

export const RowActions = styled.div`
  display: flex;
  justify-content: center;
  gap: 0.25rem;
`
